<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="couponId" >
        <span slot="label" >
          <a-tooltip>
            优惠券ID<template slot="title">优惠券ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.couponId"  :placeholder="$t('请输入')+'优惠券ID'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            用户ID<template slot="title">用户ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="receiveTime" >
        <span slot="label" >
          <a-tooltip>
            领券时间<template slot="title">领券时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.receiveTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            优惠券状态 0:失效 1:有效 2:使用过 3:售后冻结<template slot="title">优惠券状态 0:失效 1:有效 2:使用过 3:售后冻结</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="useStartTime" >
        <span slot="label" >
          <a-tooltip>
            开始时间<template slot="title">开始时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.useStartTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="useEndTime" >
        <span slot="label" >
          <a-tooltip>
            结束时间<template slot="title">结束时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.useEndTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="bundledCount" >
        <span slot="label" >
          <a-tooltip>
            捆绑数量<template slot="title">捆绑数量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.bundledCount"  :placeholder="$t('请输入')+'捆绑数量'" />
      </a-form-model-item>
      <a-form-model-item prop="usedCount" >
        <span slot="label" >
          <a-tooltip>
            使用数量<template slot="title">使用数量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.usedCount"  :placeholder="$t('请输入')+'使用数量'" />
      </a-form-model-item>
      <a-form-model-item prop="getWay" >
        <span slot="label" >
          <a-tooltip>
            获取方式 1客户领取 2:平台发放 3:购买 4:下单返券<template slot="title">获取方式 1客户领取 2:平台发放 3:购买 4:下单返券</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.getWay"  :placeholder="$t('请输入')+'获取方式 1客户领取 2:平台发放 3:购买 4:下单返券'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCouponUser, addCouponUser, updateCouponUser } from '@/api/activity/couponUser'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        couponId: null,

        userId: null,

        receiveTime: null,

        status: 0,

        useStartTime: null,

        useEndTime: null,

        bundledCount: null,

        usedCount: null,

        getWay: null,

        createTime: null,

        remark: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        couponId: null,
        userId: null,
        receiveTime: null,
        status: 0,
        useStartTime: null,
        useEndTime: null,
        bundledCount: null,
        usedCount: null,
        getWay: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCouponUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCouponUser(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCouponUser(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
